import client from '../fundaApiClient'

export default {
  getFundingAnnouncements(idxes) {
    return client.get(`/funding/announcement?idxes=${idxes.toString()}`)
  },
}
